import { Box, Button, Modal } from "@bcc-ui/ui-components";
import * as React from "react";
import { useTranslation } from "react-i18next";

import style from "./audit-log-dialog.scss";
import { AuditLog } from "domain/auditLog";
import { formatTimestamp } from "utils/format";

import testIds from "testIds.json";

interface Props {
    auditLog?: AuditLog;
    onClose: () => void;
}

function AuditLogDetailDialog(props: Props) {
    const { t } = useTranslation();

    const log = props.auditLog;

    const fields: { label: string; value: string | undefined; isData?: boolean }[] = log
        ? [
              { label: t("AuditLogs.detail.username"), value: log.username },
              { label: t("AuditLogs.detail.userUuid"), value: log.userUuid },
              { label: t("AuditLogs.detail.ip"), value: log.ip },
              { label: t("AuditLogs.detail.licenseKey"), value: log.licenseKey },
              { label: t("AuditLogs.detail.action"), value: log.action },
              { label: t("AuditLogs.detail.eventType"), value: log.eventType },
              { label: t("AuditLogs.detail.creationTime"), value: formatTimestamp(log.creationTime) },
              {
                  label: t("AuditLogs.detail.data"),
                  value: log.data ? JSON.stringify(log.data, null, 2) : undefined,
                  isData: !!log.data,
              },
          ]
        : [];

    return (
        <Modal
            isOpen={!!log}
            hideModal={props.onClose}
            title={log && t("AuditLogs.detailViewTitle", { uuid: log.uuid })}
            width="Lg"
            className={style.detailDialog}
            testId={testIds.workArea.auditLogs.logs.detailDialog.itself}
            buttons={
                <Button variant="Primary" onClick={props.onClose} testId={testIds.common.dialog.closeButton}>
                    {t("Common.ok")}
                </Button>
            }
        >
            <div className={style.scrollableContent}>
                {fields.map(({ label, value, isData }) => (
                    <Box
                        key={label}
                        gap="Xs"
                        paddingTop="Xs"
                        paddingBottom="Xs"
                        columnLayout={isData}
                        className={isData ? undefined : style.fieldRow}
                    >
                        <span className={style.label}>{label}</span>
                        {isData ? (
                            <pre className={style.dataValue}>{value}</pre>
                        ) : (
                            <span className={style.value}>{value ?? t("Common.na")}</span>
                        )}
                    </Box>
                ))}
            </div>
        </Modal>
    );
}

export default AuditLogDetailDialog;
